import { ContentfulComponentHero, ContentfulHeroSection } from '@reward-platform/contentful'

/**
 *
 * @deprecated old content model "heroSection" to be removed once new hero is created and old content is migrated
 */
const getLegacyHeroWithVariant = (
  contentfulHero: ContentfulComponentHero | ContentfulHeroSection | undefined
): ContentfulHeroSection | undefined => {
  if (!contentfulHero) {
    return undefined
  }
  const hero = contentfulHero.variant ?? contentfulHero
  switch (hero.contentType) {
    case 'heroSection':
      return hero
    case 'component-hero':
      return {
        entryId: hero.identifier,
        heading: hero.heading,
        image: hero.image,
        bynderImage: hero.bynderImage,
        body: hero.bodyCopy,
        contentType: 'heroSection',
      }
    default:
      return undefined
  }
}

export const getHeroWithVariant = getLegacyHeroWithVariant
